import styled from 'styled-components';
import type { DefaultTheme } from 'styled-components';
import type { HowItWorksPageQuery } from '@graphql/pages/how-it-works.generated';
import HowItWorksInfoSection from './HowItWorksInfoSection';
import MediaQueryHelper from '../../../templates/MediaQueryHelper';
import HeaderSection from '../shared/HeaderSection';

type Props = { howItWorksPageData: HowItWorksPageQuery['howItWorksPage']; pageTitle: string | null | undefined };

const HiddenH1 = styled.h1`
  position:absolute;
  left:-10000px;
  top:auto;
  width:1px;
  height:1px;
  overflow:hidden;
`;

const HowItWorksPageContent = (props: Props) => {
  const {
    howItWorksPageData,
    pageTitle = '',
  } = props;

  const headerSection = howItWorksPageData?.headerSection || {};
  const infoSections = howItWorksPageData?.infoSections || [];

  const createInfoSections = (isMobile: boolean) => (infoSections || [])
    .filter((section) => section !== null)
    .map((section, index) => (
      <HowItWorksInfoSection
        key={`how-it-works-info-section-${section.id}`}
        sectionData={section}
        backgroundColor={(
            section.backgroundColor
            || (index % 2 === 0 ? (p: { theme: DefaultTheme }) => p.theme.c.bg.primary
              : (p: { theme: DefaultTheme }) => p.theme.c.bg.secondary)
          )}
        isMobile={isMobile}
      />
    ));

  const desktopPage = (
    <div>
      <HiddenH1>{ pageTitle }</HiddenH1>
      <HeaderSection headerSectionData={headerSection} />
      { createInfoSections(false) }
    </div>
  );

  const mobilePage = (
    <div>
      <HiddenH1>{ pageTitle }</HiddenH1>
      <HeaderSection isMobile headerSectionData={headerSection} />
      { createInfoSections(true) }
    </div>
  );

  const renderComp = (
    <MediaQueryHelper
      desktopChildren={desktopPage}
      mobileChildren={mobilePage}
    />
  );

  return renderComp;
};

export default HowItWorksPageContent;
